import {Fragment} from "react";
import {useTick} from "./useGame.js";

// A chance card's moment on a phone: the coin in the air, the die tumbling, the names
// the roulette runs over, the wheel — then the result and what it means for this player.
// Every angle, face and highlight comes from controller.gambleReveal(); this component
// only re-renders fast enough to show them move.
export function GambleReveal({controller}) {
  const reveal = controller.gambleReveal();
  // Thirty frames a second while it spins; a slow beat while the result is up, so it
  // still goes away on time.
  useTick(Boolean(reveal), reveal?.phase === "rolling" ? 33 : 300);
  if (!reveal) return null;
  const landed = reveal.phase === "result";

  return (
    <section
      className={`gamble-reveal kind-${reveal.kind}${landed ? ` landed tone-${reveal.tone}` : ""}`}
      aria-live="polite"
      onClick={() => controller.dismissGambleReveal()}
    >
      <div className="gamble-dialog">
        <p className="eyebrow">{reveal.playerName} spelar {reveal.cardName}</p>
        <p className="gamble-caption">{reveal.caption}</p>
        <div className="gamble-prop">
          {reveal.coin && (
            <div
              className="gamble-coin"
              style={{transform: `translateY(${-reveal.coin.lift * 70}px) rotateX(${reveal.coin.angle}deg)`}}
            >
              <span className="coin-face krona">♛<small>Krona</small></span>
              <span className="coin-face klave">1<small>Klave</small></span>
            </div>
          )}
          {reveal.die && (
            <div className="gamble-die">
              {reveal.die.pips.map((on, cell) => <i key={cell} className={on ? "on" : ""}></i>)}
            </div>
          )}
          {reveal.wheel && (
            <div className="gamble-wheel-wrap">
              <div
                className="gamble-wheel"
                style={{transform: `rotate(${reveal.wheel.angle}deg)`, "--count": reveal.wheel.segments.length}}
              >
                {reveal.wheel.segments.map((label, index) => (
                  <span key={index} className={landed && index === reveal.wheel.pointer ? "hit" : ""} style={{"--i": index}}>
                    {label}
                  </span>
                ))}
              </div>
              <span className="gamble-pointer" aria-hidden="true"></span>
            </div>
          )}
          {reveal.duel && (
            <div className="gamble-duel">
              {reveal.duel.map((side, index) => (
                <Fragment key={index}>
                  {index === 1 && <span className="duel-versus">mot</span>}
                  <div className={`duel-side${side.rolling ? "" : " settled"}${side.lost ? " lost" : ""}`}>
                    <div className="gamble-die">
                      {side.pips.map((on, cell) => <i key={cell} className={on ? "on" : ""}></i>)}
                    </div>
                    <span className="duel-name">{side.name}</span>
                  </div>
                </Fragment>
              ))}
            </div>
          )}
          {reveal.bottle && (
            <div className="gamble-bottle-ring">
              {reveal.bottle.names.map((entry) => (
                <span key={entry.id} className={entry.picked ? "picked" : ""} style={{"--at": `${entry.at}deg`}}>
                  {entry.name}
                </span>
              ))}
              <div className="gamble-bottle-pivot" style={{transform: `translate(-50%, -50%) rotate(${reveal.bottle.angle}deg)`}}>
                <div className="gamble-bottle">
                  <span className="bottle-neck"></span>
                  <span className="bottle-body"></span>
                </div>
              </div>
            </div>
          )}
          {reveal.roulette && (
            <ul className="gamble-roulette">
              {reveal.roulette.map((entry) => (
                <li key={entry.id} className={entry.picked ? "picked" : entry.spot ? "spot" : ""}>{entry.name}</li>
              ))}
            </ul>
          )}
        </div>
        {landed ? (
          <div className="gamble-result">
            <h2>{reveal.headline}</h2>
            <p>{reveal.detail}</p>
            {reveal.personal && <p className="gamble-personal">{reveal.personal}</p>}
            <span className="gamble-hint">Tryck för att stänga</span>
          </div>
        ) : (
          <p className="gamble-wait" aria-hidden="true">
            <span>●</span><span>●</span><span>●</span>
          </p>
        )}
      </div>
    </section>
  );
}
